import Vue from 'vue';

import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

class SentryClient {
  static enableSentry() {
    Sentry.init({
      Vue,
      dsn: process.env.VUE_APP_SENTRY_DNS,
      sampleRate: process.env.NODE_ENV === 'production' ? 0.05 : 1,
      tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.01 : 1,
      environment: process.env.NODE_ENV,
      integrations: [
        new Integrations.BrowserTracing({
          tracingOrigins: ['localhost', 'descomplica.io', /^\//],
        }),
      ],
      trackComponents: true,
    });
  }

  static captureError(error: Error | unknown) {
    Sentry.captureException(error);
  }
}

export default SentryClient;
